module.exports = __webpack_public_path__ + "static/media/sarigama.939869d7.png";